import { useState, useEffect, useRef } from "react";

export function LocationAutocomplete({ value, onChange, inputStyle, placeholder = "Add a place..." }) {
  const [query, setQuery] = useState(value || "");
  const [results, setResults] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const boxRef = useRef(null);
  const debounceRef = useRef(null);

  useEffect(() => { setQuery(value || ""); }, [value]);
  useEffect(() => {
    const onDocClick = (e) => { if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, []);

  const search = (q) => {
    if (debounceRef.current) clearTimeout(debounceRef.current);
    if (!q || q.trim().length < 3) { setResults([]); setLoading(false); setOpen(false); return; }
    setLoading(true);
    // Debounced to respect Nominatim's 1 req/sec usage policy.
    debounceRef.current = setTimeout(async () => {
      try {
        const res = await fetch(`https://nominatim.openstreetmap.org/search?format=json&addressdetails=1&limit=5&q=${encodeURIComponent(q)}`, { headers: { Accept: "application/json" } });
        const data = await res.json();
        setResults(Array.isArray(data) ? data : []);
        setOpen(true);
      } catch { setResults([]); }
      finally { setLoading(false); }
    }, 500);
  };

  const handleChange = (e) => { const v = e.target.value; setQuery(v); onChange(v); search(v); };
  const pick = (r) => { setQuery(r.display_name); onChange(r.display_name); setResults([]); setOpen(false); };

  return (
    <div ref={boxRef} style={{ position: "relative" }}>
      <input value={query} onChange={handleChange} onFocus={() => results.length && setOpen(true)} style={inputStyle} placeholder={placeholder} />
      {open && (loading || results.length > 0) && (
        <div style={{ position: "absolute", top: "100%", left: 0, right: 0, zIndex: 60, marginTop: 4, background: "var(--c-bg-card)", border: "1px solid var(--c-border)", borderRadius: 10, boxShadow: "0 6px 22px rgba(60,30,50,0.18)", maxHeight: 220, overflowY: "auto" }}>
          {loading && <div style={{ padding: "10px 12px", fontSize: 12, color: "var(--c-text-soft)" }}>Searching…</div>}
          {!loading && results.map((r) => (
            <div key={r.place_id} onClick={() => pick(r)} style={{ padding: "9px 12px", fontSize: 12.5, color: "var(--c-text)", cursor: "pointer", borderBottom: "1px solid var(--c-border-light)", lineHeight: 1.4 }}>
              📍 {r.display_name}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
